import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/button';
import { ROUTES_PATHS } from '../../../constants';

export const ButtonBuyNow = ({ size }) => {
  return (
    <Link to={ROUTES_PATHS.AMAZON_SHOP}>
      <Button size={size}>Buy Now</Button>
    </Link>
  );
};
